<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item active">Настройки аккаунта</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Настройки аккаунта</h5>
			<div class="text-muted">Редактирование информации об аккаунте пользователя "{{ authModel.getLogin() }}"</div>
		</div>
		<div class="row">
			<div class="col-md-2 mb-3">
				<div class="card">
					<div class="card-header">Аватар</div>
					<div class="card-body text-center">
						<image-with-placeholder
							:src="previewAvatar || authModel.getAvatar()"
							class="mw-100 ratio ratio-1x1 rounded mb-2"
							height="100%"
							skeleton="shimmer"
							alt="ava"
						/>
						<img src="/assets/images/noimage2.png" />
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-3">
				<div class="card">
					<div class="card-header">Параметры пользователя</div>
					<div class="card-body">
						<div class="mb-3">
							<div class="form-label">Логин</div>
							<div class="d-flex align-items-center form-control">
								<code>{{ authModel.getLogin() }}</code>
							</div>
						</div>
						<div>
							<label for="inputAvatar" class="form-label">Аватар</label>
							<input ref="fileInput" class="form-control" type="file" id="inputAvatar" accept="image/*" @change="onFileChange" :disabled="loading" />
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-3">
				<div class="card">
					<div class="card-header">Сменить пароль</div>
					<div class="card-body">
						<div class="mb-3">
							<label for="inputPassword" class="form-label">Новый пароль</label>
							<div class="input-group">
								<input class="form-control font-monospace" :type="passwordShow ? 'text' : 'password'" id="inputPassword" :disabled="loading" v-model="password" />
								<button class="btn btn-outline-secondary px-2" type="button" :disabled="loading" @click="passwordShow = !passwordShow">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path v-if="passwordShow" d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
										<path v-else d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
									</svg>
								</button>
							</div>
						</div>
						<div>
							<label for="inputPassword2" class="form-label">Повтор пароля</label>
							<div class="input-group">
								<input class="form-control font-monospace" :type="passwordShow ? 'text' : 'password'" id="inputPassword2" :disabled="loading" v-model="password2" />
								<button class="btn btn-outline-secondary px-2" type="button" :disabled="loading" @click="passwordShow = !passwordShow">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path v-if="passwordShow" d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z" />
										<path v-else d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z" />
									</svg>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card">
			<div class="card-body">
				<div class="d-grid gap-2 d-md-flex justify-content-md-end">
					<button
						type="button"
						class="btn btn-primary d-flex align-items-center justify-content-center"
						@click="saveProfile"
    					:disabled="loading"
					>
						<span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
						<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
							<path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
						</svg>
						<span class="ms-2">{{ loading && loadingSave ? 'Сохранение...' : 'Сохранить изменения' }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Настройки аккаунта | SKV'});
	},
	data: () => ({
		loading: false,
		passwordShow: false,
		password: '',
		password2: '',
		previewAvatar: null,
	}),
	methods: {
		onFileChange(e) {
			const file = e.target.files[0];
			if (!file || !file.type.match('image.*')) {
				this.resetFile();
				return;
			}
			this.previewAvatar = URL.createObjectURL(file);
		},
		resetFile() {
			this.previewAvatar = null;
			if (this.$refs.fileInput) this.$refs.fileInput.value = '';
		},
		async saveProfile() {
			if (this.password && this.password !== this.password2) {
				this.$toast.error("Пароли не совпадают!");
				return;
			}

			this.loading = true;
			try {
				const formData = new FormData();
				if (this.password) {
					formData.append('password', this.password);
					formData.append('password2', this.password2);
				}

				const fileInput = this.$refs.fileInput;
				if (fileInput && fileInput.files[0]) {
					formData.append('avatar_file', fileInput.files[0]);
				}

				const result = await this.appModel.doUpdateProfile(formData);
				
				if (result.success) {
					// Обновляем данные в authModel, чтобы аватар сменился в шапке
					if (result.data.avatar) {
						this.authModel.userProfile.avatar = result.data.avatar;
					}
					this.password = '';
					this.password2 = '';
				} else {
					this.$toast.error(result.message);
				}
			} finally {
				this.loading = false;
			}
		}
	},
	components: {
		ImageWithPlaceholder,
	},
};
</script>
